module.exports = __webpack_public_path__ + "media/images/thebowtieduck-ff988f697e3516c1f594161eab27cd73.png";